import { $element, $elements, $elementChild } from "@common/helpers/elements";

const ACTIVE_CLASS = "active";
const DOWN_ARROW_BLACK = "down-arrow-black";
const TRANSITION_TIME = 1150;
const WHITE_COLOR = "rgb(255, 255, 255)";

function init($views) {
	const $view = $views[0];
	const $animations = $elements("animations");
	const $wrapper = $element("wrapper");
	const $content = $element("content");
	const $footer = $element("section-footer");
	const $footerScroll = $elementChild($footer, "footer-scroll");
	const $slides = Array.prototype.slice.call(document.querySelectorAll(".scroll-section"));
	const $window = $(window);
	const $hero = $element("hero");
	const $downArrows = Array.prototype.slice.call(document.querySelectorAll("span.scrolling-campaign-down-arrow"));

	if (!$view.dataset.immersive) {
		$window.on("campaignNavigation", (_event, id) => {
			const $reference = $slides.find(($slide) => {
				const $child = $elementChild($slide, "section-navigation");
				return $child && $child.dataset.href.toLowerCase() === id.toLowerCase();
			});

			if ($reference) {
				var timeout = setTimeout(() => {
					window.scrollTo(0, $reference.offsetTop);
					clearTimeout(timeout);
				});
			}
		});
		return;
	}

	document.body.style.overflow = "hidden";
	document.body.style.height = "100vh";
	if ($footer) {
		$footer.style.bottom = "-" + $footer.offsetHeight + "px";
	}

	modifyImmersiveVideos();

	const slider = {
		index: $hero ? -1 : 0,
		navigation: false,
		inProgress: null,
	};

	if (!$hero && $slides[0]) {
		$slides[0].classList.add(ACTIVE_CLASS);
	}

	function modifyImmersiveVideos() {
		const $immersiveVideos = document.querySelectorAll(".video-container");

		$immersiveVideos.forEach(($video) => {
			$video.classList.add("half_width");
		});
	}

	function videos() {
		const $videos = $view.querySelectorAll("video");
		$videos.forEach(($video) => $video.pause());
	}

	function siblings() {
		const $current = $slides[slider.index];
		const $previous = $slides[slider.index - 1];
		const $next = $slides[slider.index + 1];
		const $child = $current ? $elementChild($current, "section-child") : null;
		const $scroll = $current && !slider.navigation ? $elementChild($current, "section-scroll") : null;

		return {
			$current,
			$previous,
			$next,
			$child,
			$scroll,
		};
	}

	function nav($slide, type) {
		if ($slide) {
			$window.trigger("campaignNavigationMenu", [$slide.dataset.href, type || $slide.dataset.type]);
		}
	}

	function slide(where) {
		if (!slider.inProgress && where()) {
			slider.inProgress = setTimeout(() => {
				clearTimeout(slider.inProgress);
				slider.inProgress = null;
			}, TRANSITION_TIME);
			return true;
		}

		return false;
	}

	function up() {
		const { $current, $previous, $child, $scroll } = siblings();
		const footerActive = $wrapper.classList.contains(ACTIVE_CLASS);
		const scrolledToTop = !$scroll || Math.round($scroll.scrollTop) <= 0;

		if (footerActive && $footerScroll.scrollTop <= 0) {
			$content.style.bottom = "0px";
			$footer.style.bottom = "-" + $footer.offsetHeight + "px";
			$wrapper.classList.remove(ACTIVE_CLASS);
			return true;
		} else if (!footerActive && scrolledToTop) {
			if ($child && $child.classList.contains(ACTIVE_CLASS)) {
				$child.classList.remove(ACTIVE_CLASS);
				const $section = $elementChild($current, "section-navigation");
				nav($section);
				videos();
				adjustDownArrowColor($section);
				return true;
			} else if (slider.index > 0) {
				$current.classList.remove(ACTIVE_CLASS);
				$previous.classList.add(ACTIVE_CLASS);
				slider.index--;

				const $prevChild = $elementChild($previous, "section-child");
				if ($prevChild && !$child) {
					nav($prevChild, "child");
					adjustDownArrowColor($prevChild);
				} else if ($prevChild && $child) {
					nav($elementChild($previous, "section-navigation"));
					nav($prevChild, "child");
					adjustDownArrowColor($prevChild);
				} else {
					const $section = $elementChild($previous, "section-navigation");
					nav($section);
					adjustDownArrowColor($section);
				}
				videos();
				return true;
			}
		}

		return false;
	}

	function down() {
		const { $next, $child, $scroll } = siblings();
		const scrolledDown = !$scroll || Math.round($scroll.offsetHeight + $scroll.scrollTop) >= $scroll.scrollHeight;

		if ($child && !$child.classList.contains(ACTIVE_CLASS)) {
			nav($child, "child");
			$child.classList.add(ACTIVE_CLASS);
			videos();
			adjustDownArrowColor($child);
			return true;
		} else if (slider.index >= $slides.length - 1 && scrolledDown) {
			$wrapper.classList.add(ACTIVE_CLASS);
			$content.style.bottom = $footer.offsetHeight + "px";
			$footer.style.bottom = "0px";
			videos();
			return true;
		} else if (scrolledDown) {
			$next.classList.add(ACTIVE_CLASS);
			slider.index++;
			videos();
			const $section = $elementChild($next, "section-navigation");
			nav($elementChild($next, "section-navigation"));
			adjustDownArrowColor($section);
			return true;
		}

		return false;
	}

	function adjustDownArrowColor($current) {
		const downArrow = $downArrows.find((arrow) => arrow.classList.contains("main-content-area-arrow"));
		const backgroundColor = window.getComputedStyle($current).getPropertyValue("background-color");

		if (backgroundColor === WHITE_COLOR) {
			downArrow.classList.add(DOWN_ARROW_BLACK);
		} else {
			downArrow.classList.remove(DOWN_ARROW_BLACK);
		}
	}

	$wrapper.addEventListener("wheel", (event) => {
		if (event.deltaY < 0) {
			slide(up);
		} else if (event.deltaY > 0) {
			slide(down);
		}
	});

	const touch = {
		startY: 0,
		endY: 0,
	};

	$wrapper.addEventListener("touchstart", (event) => {
		touch.startY = event.changedTouches[0].screenY;
	});

	$wrapper.addEventListener("touchend", (event) => {
		touch.endY = event.changedTouches[0].screenY;

		if (touch.endY < touch.startY) {
			slide(down);
		} else if (touch.endY > touch.startY) {
			slide(up);
		}
	});

	$downArrows.forEach((arrow) =>
		arrow.addEventListener("click", () => {
			slide(down);
		}),
	);

	document.addEventListener("keydown", (event) => {
		if ([38, 33].includes(event.which) && !slide(up)) {
			const { $scroll } = siblings();

			if ($scroll) {
				$scroll.scrollTop -= 50;
			}
		} else if ([40, 34].includes(event.which) && !slide(down)) {
			const { $scroll } = siblings();

			if ($scroll) {
				$scroll.scrollTop += 50;
			}
		}
	});

	function heights() {
		const height = document.body.offsetWidth > 1024 ? document.body.offsetHeight - 78 : document.body.offsetHeight - 63;
		$animations.forEach(($animation) => ($animation.style.height = height + "px"));
	}

	["load", "resize"].forEach((name) => window.addEventListener(name, heights));

	function navigation(_event, id) {
		const index = $slides.findIndex(($slide) => {
			const $child = $elementChild($slide, "section-navigation");
			return $child && $child.dataset.href === id;
		});

		if (index >= 0 && index <= $slides.length - 1) {
			const direction = index > slider.index ? down : up;
			slider.navigation = !slider.navigation;
			while (slider.index !== index) {
				direction();
			}
			slider.navigation = !slider.navigation;
		}
	}

	$window.on("campaignNavigation", navigation);
}

export const scrollingCampaignPage = {
	view: "scrolling-campaign-page",
	init,
};
